import { tracker } from "@openreplay/tracker";
import { GetLoggedInUserQuery } from "types/graphql-schema";

type OpenReplayUser = Pick<
  NonNullable<GetLoggedInUserQuery["me"]>,
  "email" | "hasSyncedCalendar" | "id" | "name"
>;

const OPENREPLAY_PROJECT_KEY = "Ou2klB0v1MoVWdjKwIte";
const OPENREPLAY_INGEST_POINT = "https://sessions.topicflow.com/ingest";

let configured = false;
let startPromise: Promise<void> | null = null;

function getUserID(user: OpenReplayUser) {
  return user.email || String(user.id);
}

function getMetadata(user: OpenReplayUser) {
  return {
    userId: String(user.id),
    displayName: user.name || "",
    email: user.email || "",
    hasSyncedCalendar: String(user.hasSyncedCalendar),
  };
}

function ensureConfigured() {
  if (configured) {
    return;
  }
  tracker.configure({
    projectKey: OPENREPLAY_PROJECT_KEY,
    ingestPoint: OPENREPLAY_INGEST_POINT,
    obscureTextEmails: false,
    obscureInputEmails: false,
    defaultInputMode: 0,
  });
  configured = true;
}

function syncUser(user: OpenReplayUser) {
  tracker.setUserID(getUserID(user));

  Object.entries(getMetadata(user)).forEach(([key, value]) => {
    tracker.setMetadata(key, value);
  });
}

export function initializeOpenReplay(user: OpenReplayUser) {
  ensureConfigured();

  if (!startPromise) {
    startPromise = tracker
      .start({
        userID: getUserID(user),
        metadata: getMetadata(user),
      })
      .then(() => undefined)
      .catch((error) => {
        startPromise = null;
        throw error;
      });
    return startPromise;
  }

  return startPromise.then(() => {
    syncUser(user);
  });
}

export function resetOpenReplayForTests() {
  configured = false;
  startPromise = null;
}
